import React, { FunctionComponent, useState } from 'react';
import './Header.css';
import { useLocale } from '../../../contexts/LocaleProvider';
import { NavLink } from 'react-router-dom';
import LogoImage from '../../../static/group_image/YAGEO-GROUP.png';
import Image from 'next/image';
import { IntlProvider } from 'react-intl';
import HeaderSearchBar from './HeaderSearchBar';
import LanguageSelector from './LanguageSelector';
import HeaderMenuList from './HeaderMenuList';
import HeaderMenuButton from './HeaderMenuButton';
import { useDevice } from '../../../contexts/DeviceContext';
import { getCurrentLayout } from '../../../utils/ChooseLayout';

interface HeaderProps {}

const Header: FunctionComponent<HeaderProps> = () => {
    const { locale, messages } = useLocale();
    const { width } = useDevice();
    const layout = getCurrentLayout(width);

    // Testing out nested menu for "Products" menu: https://mui-nested-menu.vercel.app/nested-menu-item
    const [anchorEl, setAnchorEl] = useState<any>(null);
    const handleClick = (e: React.MouseEvent) => {
        if (anchorEl) {
            return;
        }
        setAnchorEl(e.currentTarget);
    };

    return (
        <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
            <header className="header-box" style={{ borderBottom: 'solid 0.063rem #e5673e' }}>
                <div className="header-container">
                    <nav>
                        <NavLink to="/">
                            <Image
                                src={LogoImage}
                                alt="YAGEO GROUP Logo"
                                className="logo"
                                priority={true}
                            />
                        </NavLink>
                    </nav>
                    {['medium', 'small', 'extra_small'].includes(layout) ? null : (
                        <HeaderMenuList />
                    )}
                    <div className="frame49">
                        <div className="lang-menu-group">
                            <LanguageSelector />
                            {['medium', 'small', 'extra_small'].includes(layout) ? (
                                <HeaderMenuButton />
                            ) : null}
                        </div>
                        <HeaderSearchBar />
                    </div>
                </div>
                <div className={`overlay ${!!anchorEl ? 'visible' : ''}`} onClick={handleClick} />
            </header>
        </IntlProvider>
    );
};

export default Header;
